import StockcarsAPI from 'api-client/StockCarsNew'
import StoreConnector from '@/helpers/StoreConnector'
import { EventBus } from '@/plugins/event-bus'

const StockCarsServiceNew = {
  async getStockCars(
    page,
    size,
    search,
    status,
    includeNationWide,
    orderBy = 'commissionNumber',
    orderDirection = 'asc'
  ) {
    try {
      const result = await StockcarsAPI.getStockcarsNew({
        page,
        size,
        search,
        status,
        includeNationWide,
        orderBy,
        orderDirection,
      })

      StoreConnector.dispatch('stockcarsNew/addStockCars', result)
      return Promise.resolve(result?.length || 0)
    } catch (e) {
      EventBus.$emit('notification-warning', 'StockCarsNewGetFailed')
      return Promise.resolve()
    }
  },
  async resetStockCars() {
    await StoreConnector.dispatch('stockcarsNew/reset')
  },

  async getSyntecReservation(commissionNumber) {
    try {
      return await StockcarsAPI.getSyntecReservationNew(commissionNumber)
    } catch (e) {
      EventBus.$emit('notification-warning', 'SyntecReservationGetFailed')
      return null
    }
  },

  async getStockCarQuotes(commissionNumber, commissionYear) {
    try {
      const result = await StockcarsAPI.getStockCarQuotes(commissionNumber, commissionYear)
      return result
    } catch (e) {
      EventBus.$emit('notification-warning', 'StockCarQuotesGetFailed')
      return null
    }
  },

  async getStockCarIdFromCommissionNumber(commissionNumber, commissionYear) {
    try {
      const response = await axios.get(
        '/api/secured/carsalestool/GetStockCarIdFromCommissionNumber',
        {
          params: { commissionNumber, commissionYear },
        }
      )
      return response.data
    } catch (e) {
      console.error('Error fetching stock car ID:', e)
      return null
    }
  },
}

export default StockCarsServiceNew
